import { useState, useEffect } from 'react';

const DISMISS_KEY = 'hivetivity-feedback-card-dismissed';
const DISMISS_DURATION = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

export const useFeedbackCardDismiss = () => {
  const [isDismissed, setIsDismissed] = useState(true); // Default to true to prevent flash

  useEffect(() => {
    const dismissedData = localStorage.getItem(DISMISS_KEY);
    if (dismissedData) {
      const { timestamp } = JSON.parse(dismissedData);
      const now = Date.now();
      const elapsed = now - timestamp;
      
      // If more than 30 days have passed, remove the dismissal
      if (elapsed > DISMISS_DURATION) {
        localStorage.removeItem(DISMISS_KEY);
        setIsDismissed(false);
      } else {
        setIsDismissed(true);
      }
    } else {
      setIsDismissed(false);
    }
  }, []);

  const dismissCard = () => {
    const dismissData = {
      timestamp: Date.now(),
    };
    localStorage.setItem(DISMISS_KEY, JSON.stringify(dismissData));
    setIsDismissed(true);
  };

  const resetDismissal = () => {
    localStorage.removeItem(DISMISS_KEY);
    setIsDismissed(false);
  };

  return {
    isDismissed,
    dismissCard,
    resetDismissal,
  };
};